import { Injectable, isDevMode } from '@angular/core';
import { AES, enc } from 'crypto-ts';
import { Router } from '@angular/router';
import { AlertService } from '../services/alert.service';
import { tools } from '../services/tools';
import { environment } from '../../../environments/environment';

@Injectable({
    providedIn: 'root',
})
export class deviceService {

    constructor(
        private alertService: AlertService,
        private tools: tools,
    ) { }

    public getDeviceUUID(): string {
        //let uuid = uuidv5('https://digit4ll.com', uuidv5.DNS);
        return 'cd7e9450-e693-53df-bc25-027bc3939889';
    }

    /**
     * Methode for encrypt string object (JSON for exemple) and store it in persistant file system
     * @param {boolean} value
     * @return {bool} succes state
     */
    public encrypteData(objectName: string, jsonStringify: string, companyData: boolean = true, userData: boolean = true): boolean {
        let guid = this.getDeviceUUID();
        try {
            let enctryptedData: string = AES.encrypt(jsonStringify, guid).toString();
            this.storeItem(objectName, enctryptedData, true, false, companyData, userData);
            return true;
        } catch (e) {
            console.log(e);
        }
        return false;
    }

    /**
     * Methode for dencrypt string object (JSON for exemple) from a  persistant blob object
     * @param {boolean} value
     * @return {bool} succes state
     */
    public decryptData(objectName: string, companyData: boolean = true, userData: boolean = true): Promise<string | null | undefined> {
        let guid = this.getDeviceUUID();
        return this.readItem(objectName, true, false, companyData, userData)
            .then((resp: any) => {
                if (resp != null) {
                    let bytes = AES.decrypt(resp, guid);
                    if (bytes != null) {
                        let decodeValue = bytes.toString(enc.Utf8).toString();
                        return decodeValue;
                    }
                    else return Promise.resolve(null);
                } else {
                    return Promise.resolve(null);
                }
            })
            .catch((err) => {
                return Promise.resolve(null);
            });
    }

    public storeItem(
        itemName: string,
        itemObj: string,
        override: boolean,
        isCacheItem: boolean,
        companyData: boolean = true,
        userData: boolean = true,
    ): Boolean {
        localStorage.setItem(itemName, itemObj.toString());
        return true;
    }

    public readItem(
        itemName: string,
        isStringItem: boolean,
        isCacheItem: boolean,
        companyData: boolean = true,
        userData: boolean = true,
    ): Promise<string> {
        let companyId = this.decryptDataLocalStorage('currentSubscriberID');
        let userDirectory = this.decryptDataLocalStorage('userId');
        let filePath = itemName;
        if (companyId != null && companyData) {
            itemName = companyId + '.' + itemName;
            filePath = itemName;
        }
        if (userDirectory != null && userData) {
            filePath = userDirectory + '/' + itemName;
        }
        let objReturn: any = null;
        objReturn = localStorage.getItem(itemName);
        return Promise.resolve(objReturn);
    }

    public clearItem(itemName: string): Boolean {
        localStorage.removeItem(itemName);
        return true;
    }

    public clearItemLocalStorage(itemName: string, storeInIframeStorage: boolean = false): void {
        localStorage.removeItem(itemName);
    }


    public encrypteDataLocalStorage(objectName: string, jsonStringify: string, storeInIframeStorage?: boolean): boolean {
        //for webApps with shared data use GUID generated using Shared Iframe
        let guid = this.getDeviceUUID();
        try {

            let enctryptedData: string = AES.encrypt(jsonStringify, guid).toString();
            localStorage.setItem(objectName, enctryptedData);
            return true;
        } catch (e) {
            console.log(e);
        }
        return false;
    }




    public decryptDataLocalStorage(objectName: string): any | null {
        try {
            let guid = this.getDeviceUUID();
            let resp = localStorage.getItem(objectName);
            if (resp != null && resp != 'null') {
                let bytes = AES.decrypt(resp, guid);
                if (bytes != null) {
                    let decodeValue = JSON.parse(bytes.toString(enc.Utf8).toString());
                    return decodeValue;
                }
            }
            //data receive by shared/iframe website() should be save on localstortage when event is received
            return null;
        } catch (e) {
            if (isDevMode()) console.log('---- 401 due to error on decrypting data : ' + objectName, localStorage.getItem(objectName), e);
            this.alertService.error("Fichier utilisateur corrompus, merci d'effacer les données de l'application");
            return null;
        }
    }
}
